import * as types from '../constants/reportConstants';
import appConstants from '../appConstants';
import config from './../config.js';
import moment from 'moment';
import { cleanUnitText } from '../utils/utils.js';
import { getFormattedRate, getMinMaxFractionDigits } from '../utils/utils';
import { generatePhysicalDeliveyMarginCheckFailSuffix } from './activityReducer.js';

const initialState = {
		reportData: [],
		trdAnalData: [],
		alldealtbleData:[],
		activityData:[],
		statement_AccountData: [],
		positionData:{
			defacccode:null,
	    mrgPerc:0,
	    detonlBeanMap:[],
			detFundsBeanMap:[],
			detOrderBeanMap:[],
			detUnallocBeanMap:[],
			detTransitBeanMap:[],
			detFOBeanMap:[],
		    detPhysicalBeanMap:[],
	    TQFlag:false,
	    UQFlag:false,
	    OQFlag:false,
			FOQFlag:false,
	    totfunds:0,
	    totReval:0,
	    totmargin:0,
	    margPerc:0,
	    excess:0,
			lossLmt:0
		},
		OnlinetbleData:[],
		BMData:[],
		loadRptFlag:false,
		modalFlag:false,
		trdAnalRptRandomNo:0,
		SubTrdRegisterData:[],
		fixOrdTbleData:[],
		thresholdCount:0,
  		derivedEndDate:"",
		threshFlag:false
};

const getStmtAccData = (stmtDataList) => {
  return stmtDataList.map((item,index) => {
		if((item.Col1_format).toString().split(".")[1]){
      item.Col1_format = (item.Col1_format).toString().split(".")[1].length
    }
    else{
      item.Col1_format = 0;
    }
		if(item.Col2_format){
			if((item.Col2_format).toString().split(".")[1]){
	      item.Col2_format = (item.Col2_format).toString().split(".")[1].length
	    }
	    else{
	      item.Col2_format = 0;
	    }
		}
		var Col1_RunBal= Number(parseFloat(Math.abs(item.Col1_RunBal))).toLocaleString(navigator.language,{ minimumFractionDigits: item.Col1_format });
		var Col2_RunBal= Number(parseFloat(Math.abs(item.Col2_RunBal))).toLocaleString(navigator.language,{ minimumFractionDigits: item.Col2_format });
		item.Col1_credit= (item.Col1_credit ? Number(parseFloat(item.Col1_credit)).toLocaleString(navigator.language,{ minimumFractionDigits: item.Col1_format }) : "");
		item.Col1_debit= (item.Col1_debit ? Number(parseFloat(item.Col1_debit)).toLocaleString(navigator.language,{ minimumFractionDigits: item.Col1_format }) : "");
		item.Col2_credit= (item.Col2_credit ? Number(parseFloat(item.Col2_credit)).toLocaleString(navigator.language,{ minimumFractionDigits: item.Col2_format }) : "");
		item.Col2_debit= (item.Col2_debit ? Number(parseFloat(item.Col2_debit)).toLocaleString(navigator.language,{ minimumFractionDigits: item.Col2_format }) : "");
		if(item.Col1_RunBal<0){
			item.Col1_RunBal=Col1_RunBal+" Dr";
		}else{
			item.Col1_RunBal=Col1_RunBal+" Cr";
		}
		if(item.Col2_RunBal<0){
			item.Col2_RunBal=Col2_RunBal+" Dr";
		}else{
			item.Col2_RunBal=Col2_RunBal+" Cr";
		}
    return {
      ...item
    };
  });
};

 const getAllDealData = (allDealList) => {
   return allDealList.map((item,index) => {
		 if(item.deal_type == 1){
			 item.deal_type = 'BUY';
		 }else{
			 item.deal_type = 'SELL';
		 }
	   var dec=getDecimal(item.Inst_id);
		 item.grs_qty=(Number(item.grs_qty).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
	   item.mtl_rate=(Number(parseFloat(item.mtl_rate)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }));
		 item.amt=(Number(parseFloat(item.amt)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF }));
		 // item.docdate= moment(item.docdate,appConstants.rptDateFormat).format(appConstants.rptDateFormat);
		 // item.valdate=moment(item.valdate,appConstants.rptDateFormat).format(appConstants.rptDateFormat);
		 return {
       ...item
     };
   });
 };

 const getTradeRegData = (tradeRegList,tradeType) => {
   return tradeRegList.map((item,index) => {
	   var dec=getDecimal(item.inst_desc.replace("-", ""));
		 if(tradeType==='O'){
			 item.pcs_qty=Number(parseFloat(item.pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
			 item.price=Number(parseFloat(item.price).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec });
			 if(item.OT==2){
				item.deal_type = item.deal_type == 1 ? 'BUY' : 'SELL'
	 		}else{
				item.deal_type = item.deal_type == 1 ? 'STOP BUY' : 'STOP SELL'
	 		}
	 	 }else if(tradeType==='FO'){
			item.pcs_qty=Number(parseFloat(item.pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
			item.price=Number(parseFloat(item.price).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec });
			item.deal_type = item.deal_type == 1 ? 'BUY' : 'SELL'
	 		item.fixingEvent = item.fc_desc
			item.filledTime = item.ET;
			item.cancelledTime=item.ET;
		 }else{
			 item.grs_qty=Number(parseFloat(item.grs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
			 item.amt=Number(parseFloat(item.amt).toFixed(config.AmountRoundOFF)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF });
			 item.mtl_rate=Number(parseFloat(item.mtl_rate).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec });
			 item.deal_type = item.deal_type == 1 ? 'BUY' : 'SELL'
			 item.evt_ts=moment(item.evt_ts).format(appConstants.actTimeDateTimeFormatter);
		 }
     return {
       ...item
     };
   });
 };

const getThresholdDetails=(data)=>{
		return {
			thresholdCount: data.hasOwnProperty('rptRecordsThreshold') ? data.rptRecordsThreshold : 0,
			derivedEndDate: data.hasOwnProperty('to_DATE') ? data.to_DATE : "",
		}
}

const getOnlOrderRegister = (orderRegisterList) => {
  return orderRegisterList.map((item,index) => {
		var dec=getDecimal(item.inst_id);
		item.pcs_qty=Number(parseFloat(item.pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
		item.price1=Number(parseFloat(item.price1).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec });
		if(item.OT==2){
			if(item.deal_type == 1){
				item.deal_type = 'BUY';
			}else{
				item.deal_type = 'SELL';
			}
		}else{
			if(item.deal_type == 1){
				item.deal_type = 'STOP BUY';
			}else{
				item.deal_type = 'STOP SELL';
			}
		}
    return {
      ...item
    };
  });
};

const getOrderHistoryData = (orderHistoryList) => {
  return orderHistoryList.map((item,index) => {
		if(item.OT==3){
			if(item.deal_type === "BUY"){
				item.deal_type = 'STOP BUY';
			}else{
				item.deal_type = 'STOP SELL';
			}
		}
		// item.remarks = item.event_type==="Placed" || item.event_type==="Modified" ? item.remarks+" "+(parseInt(item.VT)===6 ? moment(parseFloat(item.VTE)).format(appConstants.ymmdd) : parseInt(item.VT)===60 ? moment(parseFloat(item.VTE)).format(appConstants.validityDateFormat) : ""):item.remarks;
		item.remarks =item.remarks;
		item.ORDRMK=item.ORDRMK;
    return {
      ...item
    };
  });
};

const gettrdAnalysisData = (trdAnalysisList) => {
  return trdAnalysisList.map((item,index) => {
		if((item.Q== 0.000 || item.Q== 0 )&& (item.D==="Value @ Current Rate" || item.D==="Profit" || item.D==="Loss") ){
			item.Q="  ";
		}
		else{
		item.Q=Number(parseFloat(item.Q)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
		}
		item.AMT=Number(parseFloat(item.AMT)).toLocaleString(navigator.language,{ minimumFractionDigits: config.AmountRoundOFF,maximumFractionDigits: config.AmountRoundOFF });

		if((item.AVG== 0.000 || item.AVG== 0 ) && (item.D==="Profit" || item.D==="Loss")){
			item.AVG="  ";
		}
		else{
		item.AVG=Number(parseFloat(item.AVG)).toLocaleString(navigator.language,{ minimumFractionDigits: 6, maximumFractionDigits: 6 });
      }
	  return {
      ...item
    };
  });
};

const getFixingOrderData = (fixingOrdList) => {
  return fixingOrdList.map((item,index) => {
		var dec=getDecimal(item.inst_id);
		item.qty=Number(parseFloat(item.pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
		item.price=Number(parseFloat(item.price1).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec });
		item.filledQty=Number(parseFloat(item.pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
		item.cancelledQty=Number(parseFloat(item.pcs_qty)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
			if(item.deal_type == 1){
				item.deal_type = 'BUY';
			}else{
				item.deal_type = 'SELL';
			}
		item.fixingEvent = item.fc_desc
		item.cmdtyPair = item.stk_desc
		item.fixingDate = item.FD
		item.docNo = item.FNC
		item.orderNo = item.docno
		item.cancelledTime=item.ET;
		item.cancelledBy=item.cancelledBy;
		item.filledTime=item.ET;
    return {
      ...item
    };
  });
};

 const updatePosition = (msg) =>{
	 try{
 		var obj={};
 	 	obj.totfunds= msg.F;
 		obj.totReval= msg.R;
 		obj.excess= msg.FE;
 		obj.totmargin= msg.M;
 		obj.margPerc= msg.MP;
		obj.lossLmt= msg.L;
 		obj.TQFlag=msg.TR.length>0?true:false;
 		obj.UQFlag=msg.UA.length>0?true:false;
 		obj.OQFlag=msg.ORD.length>0?true:false;
		obj.FOQFlag=msg.FO.length>0?true:false;
		obj.margPercLable= msg.P;
		var SP = new Map();
		var SF =new Map();
		var ORD =new Map();
		var FO =new Map();
		var UA =new Map();
		var TR =new Map();
		var DL =new Map();
 	  	msg.SP.map((item,index) => {
 	    	SP.set(item.suf_code,item);
 	  	});
			msg.ORD.map((item,index) => {
				ORD.set(item.suf_code,item);
			});
			msg.FO.map((item,index) => {
				FO.set(item.suf_code,item);
			});
			msg.UA.map((item,index) => {
				UA.set(item.suf_code,item);
			});
			msg.TR.map((item,index) => {
				TR.set(item.suf_code,item);
			});
		var SF = new Map();
			msg.FB.map((item,index) => {
					SF.set(item.suf_code,item);
			});
			msg.DL.map((item,index) => {
                let Obj={};
                Obj.C=item.suf_code;
                Obj.D=item.suf_desc;
                Obj.DQ=item.fc_amt;
                Obj.format=item.suf_format;
                let objDL={};
                objDL.DO=item.amt;
                objDL.tick=item.rate;
                Obj.STK_VAL=objDL;
                DL.set(item.suf_code,Obj);
			});
  	obj.detonlBeanMap=SP;
		obj.detFundsBeanMap=SF;
		obj.detOrderBeanMap=ORD;
		obj.detFOBeanMap=FO;
		obj.detTransitBeanMap=TR;
		obj.detUnallocBeanMap=UA;
		obj.detPhysicalBeanMap=DL;
 	}
  catch(e){
 	 console.log(e);
  }
  return obj;
 }

 const getDecimal = (cmdtypair) => {
   var dec;
   const item = Object.assign([], JSON.parse(localStorage.getItem(cmdtypair)));
   //for (let index = 0; index < item.length; index++) {
    // if (item[index].I === cmdtypair) {
       dec = item.dec
       //break;
    // }
  // }
   return dec;
 }
 export function marginCheckNotification(msg){
   var obj={};
	 obj.det=msg.TS;
   //obj.det=moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo=(msg.NFD?msg.NFD:"");
     if(parseInt(msg.OT)===2 ||parseInt(msg.OT)===3 ){
       obj.docNo = (msg.NOD
         ? msg.NOD
         : "");
     }
		 // else if(parseInt(msg.OT)===5){
     //   obj.docNo = (msg.ONB
     //     ? msg.ONB
     //     : "");
     // }
		 else if(parseInt(msg.OT)===4){
       obj.docNo = (msg.DN
         ? msg.DN
         : "");
     }
   let remark="";
	 const type=(msg.OT
     ? msg.OT
     : "1");
     const msgType=msg.OMT;
	 if(parseInt(type)===1){
		 remark="Trade unsuccessful. "
	 }else if(parseInt(msgType)===2){
		 remark="Modify unsuccessful. "
	 }else if(parseInt(msgType)===6){
		 remark="Cancel unsuccessful. "
	 } else if(parseInt(type)===4){
		 remark="Fixing Order unsuccessful. "
	 }	else{
		 remark="Order unsuccessful. "
	 }
   switch(msg.STATUS)
   {
       case appConstants.TRD_ROUTE_ISSUE:remark = remark+ "The Order cannot be routed now. Please try after sometime.";break;
       case appConstants.SESSION_EXP:remark = remark+ "Your session has expired. Please login again.";break;
       case appConstants.REJ_ACCLOCKED:remark = remark+ "Trade unsuccessful. Another trader is executing in this account.";break;
       case appConstants.MRG_FAILED:remark = remark+ "Trade rejected. Insufficient margins.";break;
       case appConstants.FUNDS_REVAL_ZERO :remark = remark+ "Funds and revaluation is zero.";break;
       case appConstants.WORST_NOP_BREACH :remark = remark+ "The value of your position plus outstanding orders cannot exceed your NOP limit.";break;
       case appConstants.INVALID_DATE:remark = remark+ "The expiry time you entered falls on a non-business day.";break;
       case appConstants.ORD_FILLED:remark = remark+ "This order has already been filled and cannot be modified.";break;
       case appConstants.EXCEEDS_TRDLIMIT:remark = remark+"Trade request quantity exceeds Trade Quantity Limit.";break;
       case appConstants.EXCEEDS_EXPOSURE:remark = remark+"The value exceeds your overall exposure limit.";break;
       case appConstants.INSUFFICIENT_MRG:remark = remark+"Your margin levels are insufficient.";break;
       case appConstants.EXCEEDS_ORDLIMIT:remark = remark+"The value exceeds your per deal limit.";break;
       case appConstants.QTY_GREATER_THAN_MAX_HEDGE_QTY:remark = remark+"Quantity exceeds maximum quantity limit.";break;
	   	 case appConstants.QTY_LESS_THAN_MIN_HEDGE_QTY:remark = remark+"Quantity less than min quantity limit.";break;
       case appConstants.TRD_PROCESS_ISSUE:remark = remark+"Deal request could not be processed. Please try after some time alert.";break;
       case appConstants.NO_DEALER:remark = remark+"No Dealer available. Please try after some time.";break;
       case appConstants.TRD_DISABLED:remark = remark+"This commodity is unavailable to you. Please contact your trading desk.";break;
       case appConstants.TRD_ROUTE_ISSUE:remark = remark+"The Order cannot be routed now. Please try after sometime.";break;
       case appConstants.SESSION_EXP:remark = remark+"Your session has expired. Please login again.";break;
       case appConstants.TRD_PLACE_FAIL:remark = remark+"Trade unsuccessful. Please try again.";break;
       case appConstants.INVALID_DATE:remark = remark+"The expiry time you entered falls on a non-business day.";break;
       case appConstants.REJ_ACCLOCKED:remark = remark+"Trade unsuccessful. Another trader is executing in this account.";break;
       case appConstants.FUNDS_REVAL_ZERO:remark = remark+"Trade Unsuccessful, Funds and revaluation is zero.";break;
       case appConstants.WORST_NOP_BREACH:remark = remark+"The value of your position plus outstanding orders cannot exceed your NOP limit.";break;
       case appConstants.ORD_FILLED:remark = remark+"This order has already been filled and cannot be modified.";break;
       case appConstants.BM_NOT_VALID:remark = remark+"This benchmark is no longer available for new orders or modifications. \n Please contact your Trading Desk.";break;
			 case appConstants.MRK_ORD_CACNEL:remark = remark+ "Trader cannot modify/cancel marked orders";break;
			 case appConstants.PREV_ORDER_REQUEST_INPROGRESS:remark=msg.OMT === 2 ? "Modification request rejected. Previous modification/cancellation request is in progress." : msg.OMT === 6 ? "Cancellation request rejected. Previous modification/cancellation request is in progress.":"";break;
			 case appConstants.FX_NOT_VALID:remark=remark+ "Fixing Event not valid for the day.";break;
		case appConstants.HOLIDAY:remark=remark+ "Fixing event marked as a holiday.";break;
		case appConstants.MKT_LMT_NOT_ALLOW:remark=remark+ "Trading date falls on a holiday.";break;
	     case appConstants.WEEKNED:remark=remark+ "The Fixing date falls on a holiday.";break;
	     case appConstants.FX_OUTOF_DATE_RANGE:remark=remark+ "Fixing date is out of range.";break;
	     case appConstants.FXDATE_BEFORE_DOCDATE:remark=remark+ "The selected Fixing Date cannot be before Doc Date.";break;
	     case appConstants.FX_NOT_ALLOW:remark=remark+ "Fixing modification/cancellation not allowed after trade day.";break;
			 default: remark=remark+ "Please try again.";break;
     }
   obj.remark=remark;
   return obj;
 }
 export function getDealRcvdLogRmk(msg,cmdtypair){
	 try{
	 	var obj={};
	  var dec = getDecimal(msg.IID);
		obj.det=msg.TS;
	  //obj.det=moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
	  obj.docNo=(msg.NFD?msg.NFD:"");
	  let remark="";
	 	remark="Trade request received: ";
	     //remark=remark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
 		remark=remark+(parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL")+ " ";
 		remark=remark+" "+(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));//commBean.getSuffixFormat().format( To Ask Rekha mam
    remark=remark+" ";
    remark=remark+(msg.SC!==undefined?msg.SC:"");
	 	remark=remark+" "+cmdtypair;
	 	remark=remark+" @";
	  remark=remark+(msg.R?Number(parseFloat(msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):"0");
	  remark=remark+" ";
	  remark=remark+(msg.ST!==undefined?msg.ST:"");
 		if(msg.AC)
 			remark=remark+" for " + msg.AD;
			remark=remark+" ["+msg.UCD+"]";
		if(msg.RMK===undefined){
      msg.RMK="";
    }
		if(msg.RMK!=="" && msg.RMK!==" ")
	    remark = remark +" (Comments: "+msg.RMK + ") ";
	    obj.remark=remark;
    return obj;
	}catch(e){console.log(e);}
 }
 export function getLimitOrderreject(msg, cmdtypair) {
   var obj = {};
   var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
  // obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo = (msg.NOD
     ? msg.NOD
     : "");
   let remark = "";
   if(msg.STATUS === -2 || msg.STATUS === - 1){
    remark = remark + "Order unsuccessful. Margin levels are insufficient: ";
  }else {
    remark = remark + "Your order request was unsuccessful: ";
  }
	 remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
		 ? "BUY"
		 : "SELL")+ " " :
		 (parseInt(msg.DT) === appConstants.TRADER_BUY
			 ? "STOP BUY"
			 : "STOP SELL")+ " ");
   remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
   remark = remark + " " + (msg.SC
     ? msg.SC
     : "");
   remark = remark + " " + cmdtypair;
   remark = remark + " @" + " " + (msg.R
     ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
     : "0") + " ";
   remark = remark + (msg.ST
     ? msg.ST
     : "");
   remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
    (parseInt(msg.VT) === appConstants.DAY? "DAY" :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

   if (msg.AC)
     remark = remark + " for " + msg.AD;
     remark = remark +" ["+ msg.UCD + "] ";
     if(msg.RMK===undefined){
       msg.RMK="";
     }
     if(msg.RMK!=="" && msg.RMK!==" ")
     remark = remark +" (Comments: "+msg.RMK + ") ";
   obj.remark = remark;
   return obj;
 }
 export function getRejectedDealLogRemark(msg,cmdtypair){
  var obj={};
	obj.det=msg.TS;
   //obj.det=moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo=(msg.NFD?msg.NFD:"");
	 var dec = getDecimal(msg.IID);
   let remark="";
   if(msg.STATUS === -2 || msg.STATUS === - 1){
    remark = remark + "Trade unsuccessful. Margin levels are insufficient: ";
   }else {
    remark = remark + "Your trade request was unsuccessful: ";
   }
   //remark=remark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
   remark=remark+(parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL")+ " ";
   remark=remark+" "+(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));//commBean.getSuffixFormat().format( To Ask Rekha mam
   remark=remark+" "+(msg.SC?msg.SC:"");
   remark=remark+" "+cmdtypair;
   remark=remark+" @"+(msg.R?Number(parseFloat(msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):"0")+" "
   remark=remark+(msg.ST?msg.ST:"");
   if(msg.AC)
     remark=remark+" for " + msg.AD;
		 remark=remark+" ["+msg.UCD+"]";
		 if(msg.RMK===undefined){
       msg.RMK="";
     }
		 if(msg.RMK!=="" && msg.RMK!==" ")
     remark = remark +" (Comments: "+msg.RMK + ") ";
     obj.remark=remark;
     return obj;
 }

 export function getPartialRejectedLogRemark(msg, cmdtypair) {
   var obj = {};
   var dec = getDecimal(msg.IID);
   obj.det = msg.TS;
   
   let remark = "";
   remark = "Your trade request has been partially rejected: ";
   remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
	   ? "BUY"
	   : "SELL") + " ";
   remark = remark + " " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })); //commBean.getSuffixFormat().format( To Ask Rekha mam
   remark = remark + " " + (msg.SC
	 ? msg.SC
	 : "");
   remark = remark + " " + cmdtypair;
   remark = remark + " @" + " " + (msg.R
	 ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
	 : "0") + " ";
   if (msg.AC)
	 remark = remark + " for " + msg.AD;
	 remark = remark +" ["+ msg.UCD + "] ";
	 if(msg.RMK===undefined){
	   msg.RMK="";
	 }
	 if(msg.RMK!=="" && msg.RMK!==" ")
	 remark = remark +" (Comments: "+msg.RMK + ") ";
   obj.remark = remark;
   return obj;
 }

 export function getConfirmedDealLogRemark(msg,cmdtypair){
   var obj={};
	 var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
   //.det=msg.TS;//moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo=(msg.NFD?msg.NFD:"");
   let remark="";
   remark= msg.APSO===true ? "Square-Off Trade: " : "Trade confirmed: "
   //remark=reamark+(msg.T==="D"?"Dealer":msg.UCD)+" ";
   remark=remark+(parseInt(msg.DT) === appConstants.TRADER_BUY ? "BOUGHT" : "SOLD")+ " ";
   remark=remark+" "+(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));//commBean.getSuffixFormat().format( To Ask Rekha mam
   remark=remark+" "+(msg.SC?msg.SC:"");
   remark=remark+" "+cmdtypair;
   remark=remark+" @"+(msg.R?Number(parseFloat(msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }):"0")+" ";
   remark=remark+(msg.ST?msg.ST:"");
   if (msg.AC) remark = remark + " for " + msg.AD;
   remark = remark + " [" + msg.UCD + "]";
   if (msg.RMK === undefined) {
     msg.RMK = "";
   }
   if (msg.RMK !== "" && msg.RMK !== " ")
     remark = remark + " (Comments: " + msg.RMK + ")";
   if (msg?.PDQ && Number(msg.PDQ) > 0) {
     remark =
       remark + "; Rejected Qty: " + (Number(parseFloat(msg.PDQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff })) + " " + (msg.SC ? msg.SC : "");
   }
   obj.remark = remark;
   return obj;
 }

 export function getLogginLogout(msg){
   var obj={};
	 obj.det=msg.TS;
  // obj.det=moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo=(msg.FNC?msg.FNC:"");
	 let remark="";
	 if(msg.BCM==='7')
	 {
   	 remark=msg.UCD+" logged in.";
	}else{
		 remark=msg.UCD+" logged out.";
	}
	obj.remark=remark;
	return obj;
 }
 export function showACSettingChangeMsg(msg){
	var obj={};
	obj.det=msg.TS;
    obj.docNo=''
    obj.remark='Your account setting has changed. Please re-login.';
   return obj;
 }
 
 export function cancelPartialFilled(msg) {
	var obj = {};
	obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = (msg.NFD
	  ? msg.NFD
	  : "");
	  if(parseInt(msg.OT)===2){
		obj.docNo = (msg.NOD
		  ? msg.NOD
		  : "");
	  }else if(parseInt(msg.OT)===5){
		obj.docNo = (msg.ONB
		  ? msg.ONB
		  : "");
	  }
	let remark = "";
	  const msgType=msg.OMT;
	   if(parseInt(msgType)===6 && appConstants.ORD_PARTIAL_FILL){
		remark="Cancel order request rejected. Please contact trading desk."
	  }
	  if(parseInt(msgType)===2 && appConstants.ORD_PARTIAL_FILL){
	   remark="Modify order request rejected. Please contact trading desk."
	 }
	obj.remark = remark;
	return obj;
  }



 export function getLimitOrderReqRecd(msg, cmdtypair) {
   var obj = {};
   var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
   //obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo = (msg.NOD
     ? msg.NOD
     : "");
   let remark = "";
   if (msg.OMT === appConstants.NEWORD) {
     remark = remark + "Order request received: ";
   } else if (msg.OMT === appConstants.MODORD) {
     remark = remark + "Modify Order request received: ";
   } else if (msg.OMT === appConstants.CANCELORD) {
     remark = remark + "Cancel Order request received: ";
   }
	 remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
     ? "BUY"
     : "SELL")+ " " :
     (parseInt(msg.DT) === appConstants.TRADER_BUY
       ? "STOP BUY"
       : "STOP SELL")+ " ");
   remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
   remark = remark + " " + (msg.SC
     ? msg.SC
     : "");
   remark = remark + " " + cmdtypair;
   remark = remark + " @" + " " + (msg.R
     ? (Number(parseFloat(msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
     : "0") + " ";
   remark = remark + (msg.ST
     ? msg.ST
     : "");
     remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
     (parseInt(msg.VT) === appConstants.DAY? "DAY":parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat):  "GTC"));

   if (msg.AC)
     remark = remark + " for " + msg.AD;
		 remark=remark+" ["+msg.UCD+"]";
		 if(msg.RMK===undefined){
       msg.RMK="";
     }
		 if(msg.RMK!=="" && msg.RMK!==" ")
     remark = remark +" (Comments: "+msg.RMK + ") ";
   obj.remark = remark;
    return obj;
 }
 export function getLimitOrderPlcRecd(msg, cmdtypair) {
   var obj = {};
   var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
   //obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo = (msg.NOD
     ? msg.NOD
     : "");
   let remark = "";
	 let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
   if (msg.OMT === appConstants.NEWORD) {
     remark = remark + "Order Placed: ";
   } else if (msg.OMT === appConstants.MODORD) {
     remark = remark + "Order Modified: ";
   } else if (msg.OMT === appConstants.CANCELORD) {
     remark = remark + "Order Cancelled: ";
   }
	 remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
     ? "BUY"
     : "SELL")+ " " :
     (parseInt(msg.DT) === appConstants.TRADER_BUY
       ? "STOP BUY"
       : "STOP SELL")+ " ");
   if (msg.OMT === appConstants.CANCELORD) {
		 	let TFQ = (msg.TFQ !== undefined ? msg.TFQ : 0 );
	  	remark =remark + " " +(Number(parseFloat(showQty)-parseFloat(TFQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
	  }
 	else{
		  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
	  }
   remark = remark + " " + (msg.SC
     ? msg.SC
     : "");
   remark = remark + " " + cmdtypair;
   remark = remark + " @" + " " + (msg.R
     ? (Number(parseFloat(msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
     : "0") + " ";
   remark = remark + (msg.ST
     ? msg.ST
     : "");
   remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
      (parseInt(msg.VT) === appConstants.DAY? "DAY"
      :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

   if (msg.AC)
     remark = remark + " for " + msg.AD;
		 remark=remark+" ["+msg.UCD+"]";
		 if(msg.RMK===undefined){
       msg.RMK="";
     }
		 if(msg.RMK!=="" && msg.RMK!==" ")
     remark = remark +" (Comments: "+msg.RMK + ") ";
   obj.remark = remark;
   return obj;
 }
 export function getLmtOrderFillRecd(msg, cmdtypair){
   var obj = {};
   //let qty=msg.OS==="F" ? msg.PQ : msg.FNCQ ;
   var orderStatus = (msg.OMT === 10 || msg.OMT=== 5 ? "Order Filled" :"Order Partially Filled");
   var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
  // obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo = (msg.DN
     ? msg.DN
     : "");
   let remark = "";
   remark = remark + orderStatus+" : ";
   remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
     ? "BOUGHT"
     : "SOLD") + " ";
   remark = remark + " " + Number(parseFloat(msg.PQ).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
   remark = remark + " " + (msg.SC
     ? msg.SC
     : "");
   remark = remark + " " + cmdtypair;
   remark = remark + " @" + " " + (parseInt(msg.OT) === 3 && msg.FCP
     ? (Number((msg.FCP).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
     : (Number((msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))) + " ";
   remark = remark + (msg.ST
     ? msg.ST
     : "");
   remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
      (parseInt(msg.VT) === appConstants.DAY? "DAY"
      :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

   if (msg.AC)
     remark = remark + " for " + msg.AD;
     remark=remark + " ( "+msg.NOD+" )";
		 remark=remark+" ["+msg.UCD+"]";
		 if(msg.RMK===undefined){
       msg.RMK="";
     }
		 if(msg.RMK!=="" && msg.RMK!==" ")
     remark = remark +" (Comments: "+msg.RMK + ") ";
   obj.remark = remark;
   return obj;
 }
 export function getLmtExpLog(msg, cmdtypair){
   var obj = {};
   var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
  // obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo = (msg.NOD
     ? msg.NOD
     : "");
     let remark = "";
		 let showQty = (msg.PCEQ !== undefined ? msg.PCEQ : msg.PQ );
     remark= remark + "Order Expired: "
		 remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
       ? "BUY"
       : "SELL")+ " " :
       (parseInt(msg.DT) === appConstants.TRADER_BUY
         ? "STOP BUY"
         : "STOP SELL")+ " ");
		 remark = remark + " " + Number((parseFloat(showQty)-parseFloat((msg.TFQ !== undefined?parseFloat(msg.TFQ):0))).toFixed(config.QuantityRoundOff)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff });
		 remark = remark + " " + (msg.SC
			 ? msg.SC
			 : "");
		 remark = remark + " " + cmdtypair;
		 remark = remark + " @" + " " + (msg.R
			 ? (Number(parseFloat(msg.R).toFixed(dec)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
			 : "0") + " ";
		 remark = remark + (msg.ST
			 ? msg.ST
			 : "");
		 remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
        (parseInt(msg.VT) === appConstants.DAY? "DAY"
         : parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat):"GTC"));

		 if (msg.AC)
			 remark = remark + " for " + msg.AD;
			remark=remark+" ["+msg.UCD+"]";
			if(msg.RMK===undefined){
				 msg.RMK="";
			 }
			if(msg.RMK!=="" && msg.RMK!==" ")
			 remark = remark +" (Comments: "+msg.RMK + ") ";
		 obj.remark = remark;
     return obj;
 }

 export function getLimitOrderBrkreject(msg, cmdtypair) {
   var obj = {};
   var dec = getDecimal(msg.IID);
	 obj.det=msg.TS;
  // obj.det = moment(parseFloat(msg.TS)).format(appConstants.actTimeDateTimeFormatter);
   obj.docNo = (msg.NOD
     ? msg.NOD
     : "");
   let remark = "";
   remark = remark + "Your order request was unsuccessful: ";
	 remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
		 ? "BUY"
		 : "SELL")+ " " :
		 (parseInt(msg.DT) === appConstants.TRADER_BUY
			 ? "STOP BUY"
			 : "STOP SELL")+ " ");
   remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
   remark = remark + " " + (msg.SC
     ? msg.SC
     : "");
   remark = remark + " " + cmdtypair;
   remark = remark + " @" + " " + (msg.R
     ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
     : "0") + " ";
   remark = remark + (msg.ST
     ? msg.ST
     : "");
   remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
    (parseInt(msg.VT) === appConstants.DAY? "DAY" :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

   if (msg.AC)
     remark = remark + " For " + msg.AD;
     remark = remark +" ["+ msg.UCD + "] ";
     if(msg.RMK===undefined){
       msg.RMK="";
     }
     if(msg.RMK!=="" && msg.RMK!==" ")
     remark = remark +" (Comments: "+msg.RMK + ") ";
   obj.remark = remark;
   return obj;
 }

/*-----------Fixing Order Functions ----------- */

export function getFixingOrderReqRecd(msg, cmdtypair) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Fixing Order request received: ";
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Modify Fixing Order request received: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + " Cancel Fixing Order request received: ";
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
	remark += " "+"@"+" " +msg.FN;
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  return obj;
}

export function getFixingOrderPlcRecd(msg, cmdtypair) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
  if (msg.OMT === appConstants.NEWORD) {
    remark = remark + "Fixing Order Placed: ";
  } else if (msg.OMT === appConstants.MODORD) {
    remark = remark + "Fixing Order Modified: ";
  } else if (msg.OMT === appConstants.CANCELORD) {
    remark = remark + "Fixing Order Cancelled: ";
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BUY"
    : "SELL") + " ";
  remark = remark + " " +(Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
	remark += " "+"@"+" " +msg.FN;
  remark = remark + (msg.ST
    ? msg.ST
    : "");
  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
    if(msg.RMK===undefined){
      msg.RMK="";
    }
    if(msg.RMK!=="" && msg.RMK!==" ")
    remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  return obj;
}

export function getFixingOrderFillRecd(msg, cmdtypair) {
  var dec = getDecimal(msg.IID);
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.DN
    ? msg.DN
    : "");
  let remark = "";
  remark = remark + "Fixing Order Filled: ";
  remark = remark + "(" + (msg.FN
    ? msg.FN
    : "") + ") "
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY
    ? "BOUGHT"
    : "SOLD") + " ";
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC
    ? msg.SC
    : "");
  remark = remark + " " + cmdtypair;
  remark = remark + " @";
  remark = remark + " ";
  remark = remark + (msg.R
    ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
    : 0) + " ";
	if(msg.NOD!==undefined && msg.NOD!==""){
	remark = remark + " ("+msg.NOD+"), ";
	}
  if (msg.AC)
    remark = remark + " for " + msg.AD;
  remark = remark +" ["+ msg.UCD + "] ";
  if(msg.RMK===undefined){
    msg.RMK="";
  }
  if(msg.RMK!=="" && msg.RMK!==" ")
  remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  return obj;
}

export function getInvalidCheck(msg, cmdtypair) {
  var obj = {};
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.OrderNo
    ? msg.OrderNo
    : "");
  let remark = "";
  // if (msg.OMT === appConstants.NEWORD) {
  //   remark = remark + "Order unsuccessful. ";
  // } else if (msg.OMT === appConstants.MODORD) {
  //   remark = remark + "Modify Order unsuccessful. ";
  // } else if (msg.OMT === appConstants.CANCELORD) {
  //   remark = remark + " Cancel Order unsuccessful. ";
  // }
  // remark = remark + "Please contact your trading desk.";
	remark = remark + "Invalid Request: Trade request rejected because of invalid parameters. Please login and try again";
  obj.remark = remark;
  return obj;
}

export function getFixingOrderReject(msg, cmdtypair) {
  var obj = {};
  var dec = getDecimal(msg.IID);
  obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
  obj.docNo = (msg.NOD ? msg.NOD : "");
  let remark = "";
  if(msg.OMT === 2){
    remark = remark + "Your Modify Fixing Order request was unsuccessful: " ;
  }else if(msg.OMT === 6){
    remark = remark + "Your Cancel Fixing Order request was unsuccessful: " ;
  }else if(msg.OMT === 7){
    remark = remark + "Your Fixing Order request was unsuccessful: " ;
  }else if (msg.OMT === 1) {
    remark = remark + "Your Fixing Order request was unsuccessful: " ;
  }
  remark = remark + (parseInt(msg.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL");
  remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
  remark = remark + " " + (msg.SC ? msg.SC : "");
  remark = remark + " " + cmdtypair;
	remark += " "+"@"+" " +msg.FN;
  //remark = remark + (msg.ST ? msg.ST : "");

  if (msg.AC)
    remark = remark + " for " + msg.AD;
    remark = remark +" ["+ msg.UCD + "] ";
  if(msg.RMK===undefined){
    msg.RMK="";
  }
  if(msg.RMK!=="" && msg.RMK!==" ")
  	remark = remark +" (Comments: "+msg.RMK + ") ";
  obj.remark = remark;
  return obj;
}

/*---------- Open Position ------------- */
export function getOpenPosDealRejectRmk(msg,cmdtypair){
  var obj={};
  obj.det=msg.TS;
	obj.docNo=(msg.NOD ?msg.NOD:"");
	var dec = getDecimal(msg.IID);
	const item = Object.assign([], JSON.parse(localStorage.getItem(msg.IID)));
	const COMM2 = item.C === 2 ? (" "+item.D2) :"";
	const fixingOrderType = (msg.OT).toString() === '4';

	let remark="";
	if(msg.OT==1){
    remark = remark + "Trade unsuccessful. ";
  } else{
    if(msg.OMT===2){
      remark = remark + "Modify unsuccessful. ";
    } else if (fixingOrderType) {
		remark = remark + "Fixing Order unsuccessful. "
	} else{
      remark = remark + " Order unsuccessful. ";
    }
  }

	switch (msg.STATUS) {
    case appConstants.NOT_ENOUGH_FUND_TO_BUY:
      remark=remark+ "Not enough funds to Buy"+COMM2+ ".";
      break;
    case appConstants.NOT_ENOUGH_STK_POSITION_TO_SELL:
      remark=remark+ "Not enough position to Sell"+COMM2+ ".";
      break;
    default:
      remark=remark+ "Please try again. ";
      break;
  }

	obj.remark=remark;
	return obj;
}

 const ordModifyReject=(msg, cmdtypair)=>{
	 var obj = {};
	 var dec = getDecimal(msg.IID);
	 obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
	 obj.docNo = (msg.NOD
		 ? msg.NOD
		 : "");
	 let remark = "";
	 if(msg.STATUS === -2 || msg.STATUS === - 1){
		remark = remark + "Order unsuccessful. Margin levels are insufficient: ";
	  }else {
		remark = remark + "Your order request was unsuccessful: ";
	  }
	 remark = remark + (msg.OT === 2 ? (parseInt(msg.DT) === appConstants.TRADER_BUY
		 ? "BUY"
		 : "SELL")+ " " :
		 (parseInt(msg.DT) === appConstants.TRADER_BUY
			 ? "STOP BUY"
			 : "STOP SELL")+ " ");
	 remark = remark + " " + (Number(parseFloat(msg.PQ)).toLocaleString(navigator.language,{ minimumFractionDigits: config.QuantityRoundOff }));
	 remark = remark + " " + (msg.SC
		 ? msg.SC
		 : "");
	 remark = remark + " " + cmdtypair;
	 remark = remark + " @" + " " + (msg.R
		 ? (Number(parseFloat(msg.R)).toLocaleString(navigator.language,{ minimumFractionDigits: dec }))
		 : "0") + " ";
	 remark = remark + (msg.ST
		 ? msg.ST
		 : "");
	 remark = remark + (parseInt(msg.VT) === appConstants.GTD? "GTD "+moment(parseFloat(msg.VTE)).format(appConstants.ymmdd):
		(parseInt(msg.VT) === appConstants.DAY? "DAY" :parseInt(msg.VT) === appConstants.GTT? "GTT "+moment(parseFloat(msg.VTE)).format(appConstants.validityDateFormat): "GTC"));

	 if (msg.AC)
		 remark = remark + " For " + msg.AD;
		 remark = remark +" ["+ msg.UCD + "] ";
		 if(msg.RMK===undefined){
			 msg.RMK="";
		 }
		 if(msg.RMK!=="" && msg.RMK!==" ")
		 remark = remark +" (Comments: "+msg.RMK + ") ";
	 	obj.remark = remark;
	 return obj;
 }

const updatePhysicalDeliveryActivity = (msg) => {

	const obj = {};
	obj.det = moment(msg.TS).format(appConstants.actTimeDateTimeFormatter);
	obj.docNo = msg.DRN ? msg.DRN : "";

	const userDetail = JSON.parse(localStorage.getItem('userDetail'));
	const sysBasedUnit = cleanUnitText(userDetail.CompanyBaseName);

	const {
    BCM,
    AD,
    AC,
    CMDTY,
    TOTAL_FC_PAMT,
	CURRENCY,
    TOTAL_GQ,
    ADD_CHARGES,
    UCD,
    RMK,
    ADD_RMK,
    STOCK_QTY_FORMAT,
    STOCK_QTY_ROUND,
    STOCK_RATE_FORMAT,
    STOCK_RATE_ROUND,
  } = msg;

	const {
		PHYSICAL_DELIVERY_DELIVERED,
		PHYSICAL_DELIVERY_REQUEST_RECEIVED,
		PHYSICAL_DELIVERY_REQUEST_PLACED,
		PHYSICAL_DELIVERY_REQUEST_CANCELLED,
		PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL
	} = appConstants;

	let baseRemark = "";
	let suffixRemark = "";
	let comments = ""

	const qtyMinMax = getMinMaxFractionDigits(STOCK_QTY_FORMAT || '#,##0.000');
	const rateMinMax = getMinMaxFractionDigits(STOCK_RATE_FORMAT || '#,##0.000');
	const qtyRoundOff = STOCK_QTY_ROUND ?? 3;
	const rateRoundOff = STOCK_RATE_ROUND ?? 2;

    const formattedTotalPamt = TOTAL_FC_PAMT && getFormattedRate(TOTAL_FC_PAMT, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);
	const currency = CURRENCY || "USD";
	const formattedAddCharges = ADD_CHARGES && getFormattedRate(ADD_CHARGES, rateMinMax.minimumFractionDigits, rateMinMax.maximumFractionDigits, true, rateRoundOff);
	const formattedTotalGQ = TOTAL_GQ && getFormattedRate(TOTAL_GQ, qtyMinMax.minimumFractionDigits, qtyMinMax.maximumFractionDigits, true, qtyRoundOff);

	switch (BCM) {
		case PHYSICAL_DELIVERY_REQUEST_PLACED:
			baseRemark = "Delivery Request Placed: ";
			suffixRemark = userDetail.premiumChargedOnDelivery ? "" : `; Premium charged: ${formattedTotalPamt} ${currency}.`;
			comments = RMK ? ` (Comments: ${RMK})` : "";
			break;

		case PHYSICAL_DELIVERY_REQUEST_RECEIVED:
			baseRemark = "Delivery Request Received: ";
     		comments = RMK ? ` (Comments: ${RMK})` : "";
			break;

		case PHYSICAL_DELIVERY_REQUEST_CANCELLED:
			baseRemark = "Delivery Request Cancelled: ";
      		suffixRemark = `; Cancellation charges: ${formattedAddCharges} ${currency}.`;
			break;

		case PHYSICAL_DELIVERY_DELIVERED:
			baseRemark = "Delivery Request Processed: ";
			suffixRemark = `; Premium charged: ${formattedTotalPamt} ${currency}.`;
			comments = ADD_RMK ? ` (Comments: ${ADD_RMK})` : "";
			break;

		case PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL:
			baseRemark = "Delivery Request Placement Unsuccessful. ";
			suffixRemark = generatePhysicalDeliveyMarginCheckFailSuffix(msg)
			break;

		default:
			baseRemark = "";
	}

	if (BCM === PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL) {
		obj.remark = baseRemark + suffixRemark
	} else {
		obj.remark = `${baseRemark}${formattedTotalGQ} ${sysBasedUnit} ${CMDTY} for ${AD} [${UCD}]${suffixRemark} ${comments}`;
	}
	return obj;
}

 const generateactivityData =(notificationList) =>{
   var arrayObj=[];
   try{
	 notificationList.map((item,index) => {
	  let cmdtypair="";
		if(item.BCM!==appConstants.TRD_LOGIN && item.BCM!==appConstants.TRD_LOGOUT){
	   const socketData = Object.assign([], JSON.parse(localStorage.getItem(item.IID)));
	   //for (let index = 0; index < socketData.length; index++) {
		// if (socketData[index].I === item.IID) {
			   cmdtypair=socketData.ID
			 //  break;
		// }
	  // }
	 }
     switch (item.BCM){
	     case appConstants.INITIAL_CHECKS_FAILED:
	     case appConstants.MARGIN_CHECKS_FAILED: var obj=marginCheckNotification(item);arrayObj.push(obj);break; //dispatch(break;
	     case appConstants.TRADE_REQUEST_RECEIVED: var obj=getDealRcvdLogRmk(item,cmdtypair);arrayObj.push(obj);break;
	     case appConstants.TRADE_REQUEST_REJCTED: var obj=getRejectedDealLogRemark(item,cmdtypair);arrayObj.push(obj);break;
	     case appConstants.TRADE_REQUEST_CONFIRMED: var obj=getConfirmedDealLogRemark(item,cmdtypair);arrayObj.push(obj);break;
		 case appConstants.BENCHMARK_REQ_RECD:var obj=getBmkOrderReqRecd(item,cmdtypair);arrayObj.push(obj);break;
		 case appConstants.TRD_LOGIN:var obj=getLogginLogout(item);arrayObj.push(obj);break;
		 case appConstants.TRD_LOGOUT:var obj=getLogginLogout(item);arrayObj.push(obj);break;
		 case appConstants.ORD_REQ_RECD:var obj = getLimitOrderReqRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_PLACED:var obj = getLimitOrderPlcRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.MODIFY_REQ_RECD:var obj=getLimitOrderReqRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_CANCEL_REQUEST:var obj=getLimitOrderReqRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_CANCEL:var obj=getLimitOrderPlcRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.SYNTHETIC_ORDER_CANCELLED:var obj=getLimitOrderPlcRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_MODIFIED:var obj = getLimitOrderPlcRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_UNHEDGE_FILL:var obj=getLmtOrderFillRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORDER_EXPIRED:var obj=getLmtExpLog(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORDER_UNHEDGE_EXPIRED:var obj=getLmtExpLog(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_HEDGE_FILL:var obj=getLmtOrderFillRecd(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORDER_REQUEST_REJECT:var obj = getLimitOrderreject(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.REQUEST_REJECT:var obj = getLimitOrderreject(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.BROKER_ORDER_MANUAL_CANCEL:var obj = getLimitOrderBrkreject(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_MODIFY_REJECT:var obj = ordModifyReject(item, cmdtypair);arrayObj.push(obj);break;
		 case appConstants.FIXING_ORDER_REQ_RECD:var obj = getFixingOrderReqRecd(item,cmdtypair);arrayObj.push(obj);break;
	 	 case appConstants.FIXING_ORDER_PLACED:var obj = getFixingOrderPlcRecd(item,cmdtypair);arrayObj.push(obj);break;
		 case appConstants.FIXING_ORDER_MOD_REQ_RECD:var obj = getFixingOrderReqRecd(item,cmdtypair);arrayObj.push(obj);break;
	   	 case appConstants.FIXING_ORDER_MODIFIED:var obj = getFixingOrderPlcRecd(item,cmdtypair);arrayObj.push(obj);break;
	     case appConstants.FIXING_ORDER_CANC_REQ_RECD:var obj = getFixingOrderReqRecd(item,cmdtypair);arrayObj.push(obj);break;
		 case appConstants.FIXING_ORDER_CANCELLED:var obj = getFixingOrderPlcRecd(item,cmdtypair);arrayObj.push(obj);break;
		 case appConstants.FIXING_ORDER_MANUAL_FILL:var obj = getFixingOrderFillRecd(item,cmdtypair);arrayObj.push(obj);break;
	     case appConstants.FIXING_ORDER_FILLED:var obj = getFixingOrderFillRecd(item,cmdtypair);arrayObj.push(obj);break;
	 	 case appConstants.INVALID_CHECK:var obj = getInvalidCheck(item,cmdtypair);arrayObj.push(obj);break;
	 	 case appConstants.FIXING_ORDER_REJECTED:var obj = getFixingOrderReject(item,cmdtypair);arrayObj.push(obj);break;
	 	 case appConstants.FIXING_ORDER_MODIFY_OR_CANCEL_REJECTED:var obj = getFixingOrderReject(item,cmdtypair);arrayObj.push(obj);break;
	 	 case appConstants.FIXING_REQUEST_REJCTED:var obj = getFixingOrderReject(item,cmdtypair);arrayObj.push(obj);break;
	     case appConstants.OPEN_POSITION_CHECKS_FAILED: var obj = getOpenPosDealRejectRmk(item,cmdtypair);arrayObj.push(obj);break;
		 case appConstants.ORD_PARTIAL_FILL: var obj = cancelPartialFilled(item);arrayObj.push(obj);break;
		 case appConstants.INVALID_SELL_ORDER: var obj = showACSettingChangeMsg(item);arrayObj.push(obj);break;
		 case appConstants.PHYSICAL_DELIVERY_DELIVERED: var obj = updatePhysicalDeliveryActivity(item);arrayObj.push(obj);break;
		 case appConstants.PHYSICAL_DELIVERY_REQUEST_RECEIVED: var obj = updatePhysicalDeliveryActivity(item);arrayObj.push(obj);break;
		 case appConstants.PHYSICAL_DELIVERY_REQUEST_PLACED: var obj = updatePhysicalDeliveryActivity(item);arrayObj.push(obj);break;
		 case appConstants.PHYSICAL_DELIVERY_REQUEST_CANCELLED: var obj = updatePhysicalDeliveryActivity(item);arrayObj.push(obj);break;
		 case appConstants.PHYSICAL_DELIVERY_MARGIN_CHECKS_FAIL: var obj = updatePhysicalDeliveryActivity(item);arrayObj.push(obj);break;
		 default:break;
   	  }
	});
    }catch(e){console.log(e);}
	 //console.log(JSON.stringify(arrayObj));
	return arrayObj;
 }
export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
	case types.LOAD_REPORT:
		return {
		...state,
	};
	case types.LOAD_REPORT_SUCCESS:
	//console.log("Order History reducer : "+JSON.stringify(getOrderHistory(action.result.dataObject)));
	return {
	...state,
	...getThresholdDetails(action.result),
	reportData: action.result.dataObject ? getOrderHistoryData(action.result.dataObject) : [],
		};
	case types.LOAD_REPORT_FAILURE:
	return {
	...state,
	};
	case types.EXPORT_ALLDEAL_REPORT:
 	return {
	 ...state,
 	};
	case types.EXPORT_SOA_REPORT:
		return {
			...state,
	 };
	 case types.EXPORT_POSITION_REPORT:
 		return {
 		...state,
 	 };
	case types.LOAD_ALLDEAL_REPORT:
		return {
		...state,
	 };
	case types.LOAD_ALLDEAL_REPORT_SUCCESS:
	return {
		...state,
		...getThresholdDetails(action.result),
		alldealtbleData: action.result.dataObject ? getAllDealData(action.result.dataObject) : []
	};
	case types.LOAD_ALLDEAL_REPORT_FAILURE:
	return {
	...state,
  };

	case types.LOAD_TRADEREG_REPORT:
		return {
		...state,
	 };
	case types.LOAD_TRADEREG_REPORT_SUCCESS:
	return {
		...state,
		...getThresholdDetails(action.result),
		SubTrdRegisterData: action.result.dataObject ? getTradeRegData(action.result.dataObject,action.tradeType) : []
	};
	case types.LOAD_TRADEREG_REPORT_FAILURE:
	return {
	...state,
  };

	case types.LOAD_SOA_REPORT:
		return {
		...state,
	 };
	case types.LOAD_SOA_REPORT_SUCCESS:
	return {
		...state,
		...getThresholdDetails(action.result),
		statement_AccountData: action.result.dataObject ? getStmtAccData(action.result.dataObject) : []
	};
	case types.LOAD_SOA_REPORT_FAILURE:
	return {
	...state,
  };
  case types.LOAD_ONLINE_REPORT:
		return {
		...state,
	 };
	case types.LOAD_ONLINE_REPORT_SUCCESS:
	return {
		...state,
		...getThresholdDetails(action.result),
		OnlinetbleData: action.result.dataObject ? getOnlOrderRegister(action.result.dataObject) : []
	};
	case types.LOAD_ONLINE_REPORT_FAILURE:
	return {
	...state,
  };

  case types.RESET_THRESHOLDSTATE:
	return {
	  ...state,
	  thresholdCount: 0,
	  derivedEndDate: "",
	}
	case types.LOAD_MARGIN:
	return{
		...state,
	};
	case types.LOAD_MARGIN_SUCCESS:
	return{
		...state,
		positionData:updatePosition(action.result.dataObject),
		loadRptFlag:false
	};
	case types.LOAD_MARGIN_FAILURE:
	return{
		...state,
	}
	case types.ENABLE_LOADER:
	return{
		...state,
		loadRptFlag:action.flag
	};
	case types.LOAD_ACTIVITY_REPORT:
	return{
		...state,
	}
	case types.LOAD_ACTIVITY_REPORT_SUCCESS:
	return{
		...state,
		...getThresholdDetails(action.result),
		activityData: action.result.dataObject ? generateactivityData(action.result.dataObject) : []
	}
	case types.LOAD_ACTIVITY_REPORT_FAILURE:
	return{
		...state,
	}
	case types.EXPORT_ACTIVITY_REPORT:
	return{
		...state,
	}
	case types.EXPORT_ORDER_HISTORY_REPORT:
	return{
		...state,
	}
	case types.EXPORT_BM_REPORT:
	return{
		...state,
	}
	case types. LOAD_BENCHMARK_REPORT:
	return {
	...state,
	};
	case types. LOAD_BENCHMARK_REPORT_SUCCESS:
	return {
	...state,
	BMData:JSON.parse(action.result.data)
	};
	case types. LOAD_BENCHMARK_REPORT_FAILURE:
	return {
	...state,
 };
 case types. LOAD_TRADE_ANALYSIS:
 return {
 ...state,
 };
 case types. LOAD_TRADE_ANALYSIS_SUCCESS:
 const randomNo= Math.floor((Math.random() * 1000000) + 1);
 return {
 ...state,
 ...getThresholdDetails(action.result),
 trdAnalData: action.result.dataObject ? gettrdAnalysisData(action.result.dataObject)  : [],
 trdAnalRptRandomNo:randomNo
 };
 case types. LOAD_TRADE_ANALYSIS_FAILURE:
 return {
 ...state,
};
case types.LOAD_FIXING_REPORT:
	return {
	...state,
 };
case types.LOAD_FIXING_REPORT_SUCCESS:
//console.log("fixOrdTbleData :"+JSON.stringify((action.result.dataObject)));
	return {
	...state,
	...getThresholdDetails(action.result),
	fixOrdTbleData: action.result.dataObject ? getFixingOrderData(action.result.dataObject)  : []
};
case types.LOAD_FIXING_REPORT_FAILURE:
	return {
	...state,
};
 case types.MODAL_FLAG:
 return {
 ...state,
 modalFlag:action.flag,
 };
	case types.RESET_STATE:
		return{
			...state,
			reportData: [],
			alldealtbleData:[],
			statement_AccountData:[],
			activityData:[],
			positionData:{
			totFunds:null,
			totReval:null,
			totABSReval:null,
			totMargin:null,
			curr_NOP:null,
			loss_lmt:null,
			AppMargin:null,
			free_equ:null,
			lossLmt:null,
			detonlBeanMap:[],
			detFundsBeanMap:[],
			detOrderBeanMap:[],
			detTransitBeanMap:[],
			detUnallocBeanMap:[],
			detFOBeanMap:[],
			detPhysicalBeanMap:[],
			STKA:[],
			Funds:[]},
			OnlinetbleData:[],
			BMData:[]
		}
		case types.RESET_REPORT_STATE:
		return{
				...state,
				reportData: [],
				alldealtbleData:[],
				statement_AccountData:[],
				activityData:[],
				OnlinetbleData:[],
				BMData:[]
			}
		case types.EXPORT_FIXING_ORDER_REPORT:
			return{
				...state,
			}
	default:
		return state;
	}
}
